module.exports = __webpack_public_path__ + "static/img/scan-card-bg.132129d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/scan-card-bg.png
// module id = 5urx
// module chunks = 1